<template>
    <error-layout>
        <template #errorTitle>
            {{$t('title')}}
        </template>

        <template #errorSubtitle>
            {{$t('subtitle')}}
        </template>

        <template #errorMessage>
            {{$t('message')}}
        </template>
    </error-layout>
</template>

<script>
    import ErrorLayout from '@/views/shared/ErrorLayout.vue';

    export default {
        name: "NotFound",
        components: {
            'error-layout': ErrorLayout
        }
    };
</script>

<i18n>
    {
        "hr": {
            "title": "404",
            "subtitle": "Stranica nije pronađena",
            "message": "Traženi URL nije pronađen. Ta stranica je možda uklonjena ili premještena."
        },
        "en": {
            "title": "404",
            "subtitle": "Page not found",
            "message": "The requested URL was not found. The page might be deleted or removed. Please return to the home page."
        }
    }
</i18n>
